// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"styles_contentWrap__6ClA2","content":"styles_content__IEjpJ","center":"styles_center__44rTs"};